module.exports = __webpack_public_path__ + "static/media/image-access-pro.7c33b634.png";